import { render, staticRenderFns } from "./BasePropio.vue?vue&type=template&id=0b0f272c"
import script from "./BasePropio.vue?vue&type=script&lang=js"
export * from "./BasePropio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports